<template>
  <Header  hrefTo="#mainView"/>
  <Main heading="About Us">
      <main-view :categories="categories">
        <div class="content">
            <mission-vision v-if="section=='vision_and_mission'" />
            <success-stories v-else-if="section=='impact'"/>
            <history v-else-if="section=='history'" />
            <board v-else-if="section=='ceo_and_board'" />
            <financial-information v-else-if="section=='financial_information'" />
            <partners v-else-if="section=='partners'" />
            <who-we-are v-else />
        </div>
      </main-view>
  </Main>
  <Footer />
</template>

<script>
import { useGtag } from "vue-gtag-next";
import Header from "../../components/Header/_Header.vue"
import Main from "../../components/Main/_Main.vue";
import MainView from "../../components/MainView/_MainView.vue";
import WhoWeAre from "./views/WhoWeAre/_WhoWeAre.vue"
import MissionVision from "./views/MissionVision/_MissionVision.vue";
import SuccessStories from "./views/SuccessStories/_SuccessStories.vue";
import History from "./views/History/_History"
import Board from './views/Board/_Board.vue'
import FinancialInformation from './views/FinanciaInformation/_FinancialInformation.vue'
import Partners from './views/Partners/_Partners.vue'
import Footer from "../../components/Footer/_Footer";
import aboutCategories from '../pages.json';


export default {
  name: "About",
  data() {
    return {
      section: null,
      categories: aboutCategories.about,
    };
  },
  components: {
    Header,
    Main,
    MainView,
    MissionVision,
    SuccessStories,
    History,
    WhoWeAre,
    Board,
    FinancialInformation,
    Partners,
    Footer
  },
  watch: {
     $route(to){
       this.section=to.query.section;
     }
    }
};
</script>

<style  lang="scss">
@import "./about.scss";
</style>
